import { api } from "../base";
import type { ILedgerLotsResponse } from "@pulse-ui/codegen-v2/generated_ts/ledger_lots";
import type {
  ILedgerRepairResponse,
  LedgerRepairMode,
} from "@pulse-ui/codegen-v2/generated_ts/ledger_repair";

export {
  LedgerLotBkMatch,
  LedgerLotSpreadRole,
  LedgerLotsBkStatus,
  type ILedgerBkOnlyLeg,
  type ILedgerLot,
  type ILedgerLotSpread,
  type ILedgerLotsAccountTotal,
  type ILedgerLotsAssetTotal,
  type ILedgerLotsResponse,
} from "@pulse-ui/codegen-v2/generated_ts/ledger_lots";
export {
  LedgerRepairBucket,
  LedgerRepairLotState,
  LedgerRepairMode,
  type ILedgerRepairFinding,
  type ILedgerRepairResponse,
  type ILedgerRepairTally,
} from "@pulse-ui/codegen-v2/generated_ts/ledger_repair";

export interface LedgerLotsArgs {
  account: string;
  asset?: string;
  bk?: boolean;
  open_only?: boolean;
}

export interface LedgerRepairArgs {
  from_ts: string;
  to_ts: string;
  mode: LedgerRepairMode;
}

// Served by risk-server; Risk or Admin only, and both read-only.
const ledgerEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getLedgerLots: build.query<ILedgerLotsResponse, LedgerLotsArgs>({
      query: ({ account, asset, bk, open_only }) => ({
        url: "/api/risk/v1/ledger/lots",
        params: {
          account,
          ...(asset ? { asset } : {}),
          ...(bk === undefined ? {} : { bk }),
          ...(open_only === undefined ? {} : { open_only }),
        },
      }),
    }),
    getLedgerRepair: build.query<ILedgerRepairResponse, LedgerRepairArgs>({
      query: (params) => ({ url: "/api/risk/v1/ledger/repair", params }),
    }),
  }),
});

export const { useGetLedgerLotsQuery, useLazyGetLedgerRepairQuery } = ledgerEndpoints;
